import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { QSAReport } from 'src/modules/serasa/serasa.experian.business.types'

export type ControleParticipacoesProps = {
    controleParticipacoes?: QSAReport
}

export default function ControleParticipacoes({ controleParticipacoes }: ControleParticipacoesProps) {
    return (
        <>
            <Divider textAlign="center">Controle de Participações</Divider>
            {controleParticipacoes &&
                controleParticipacoes.partnerCompleteReport &&
                controleParticipacoes.partnerCompleteReport.partnersList &&
                controleParticipacoes.partnerCompleteReport.partnersList.length > 0 && (
                    <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                        {controleParticipacoes.partnerCompleteReport.partnersList.map((participacao, index) => (
                            <Grid key={index} container spacing={1}>
                                <GridItem label="Nome" value={participacao.name || '-'} xs={6} />
                                <GridItem label="Documento" value={participacao.documentId || '-'} xs={6} />
                                <GridItem label="Nacionalidade" value={participacao.nationality || '-'} xs={6} />
                                <GridItem label="Situação" value={participacao.status || '-'} xs={6} />
                                <GridItem
                                    label="Data de Entrada"
                                    value={
                                        participacao.sinceDate ? formatDate(participacao.sinceDate, 'dd/MM/yyyy') : '-'
                                    }
                                    xs={6}
                                />
                                <GridItem
                                    label="Participação"
                                    value={participacao.capitalTotalValue ? `${participacao.capitalTotalValue}%` : '-'}
                                    xs={6}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
        </>
    )
}
